import { render, staticRenderFns } from "./addVillage.vue?vue&type=template&id=31c043a4&scoped=true&"
import script from "./addVillage.vue?vue&type=script&lang=js&"
export * from "./addVillage.vue?vue&type=script&lang=js&"
import style0 from "./addVillage.vue?vue&type=style&index=0&id=31c043a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c043a4",
  null
  
)

export default component.exports